import React, { useRef, useEffect } from 'react';
import IDFTOfMagnitudes from './IDFTOfMagnitudes.js';
import {
  Chart,
  LineController,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
} from 'chart.js';

Chart.register(
  LineController,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler
);

const InverseFourierTransform = ({ points, width, height }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null); // Change this to useRef

  useEffect(() => {
    if (!canvasRef.current) return;
  
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
  
    const newChart = new Chart(ctx, {
      type: "line",
      data: {
        labels: [],
        datasets: [
          {
            label: "Amplitude",
            data: [],
            backgroundColor: "rgba(40, 44, 52, 1)",//"rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(40, 44, 52, 1)",//"rgba(75, 192, 192, 1)",
            borderWidth: 1,
            pointRadius: 0, // Set the point radius to 0 to hide the points
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          x: {
            type: "linear",
            beginAtZero: true,
            grid: {
              display: false, // This will hide the grid lines on the Y scale
            },
          },
          y: {
            type: "linear",
            beginAtZero: true,
            grid: {
              display: false, // This will hide the grid lines on the Y scale
            },
          },
        },
      },
    });
  
    chartRef.current = newChart; // Update chartRef with newChart
  
    // Return a cleanup function to destroy the chart instance
    return () => {
      newChart.destroy();
    };
  }, []);

  useEffect(() => {
    if (!chartRef.current || !Object.keys(points).length) return;
  
    const updateChart = () => {
      const X = IDFTOfMagnitudes(points);
      chartRef.current.data.labels = X.map((_, i) => i);
      chartRef.current.data.datasets[0].data = X;
      chartRef.current.update();
    };
  
    // Only update the chart if the number of points changes
    if (chartRef.current.data.labels.length !== Object.keys(points).length) {
      updateChart();
    }
  }, [points]);
  

  return <canvas ref={canvasRef} width={width} height={height} />;
};

export default InverseFourierTransform;


// BELOW IS CODE THAT MAKES IT WORK BUT ONLY FOR INITIAL POINTS
// import React, { useRef, useEffect } from 'react';
// import IDFTOfMagnitudes from './IDFTOfMagnitudes.js';
// import {
//   Chart,
//   LineController,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Filler,
// } from 'chart.js';

// Chart.register(
//   LineController,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Filler
// );


// const InverseFourierTransform = ({ points, width, height}) => {
//   const canvasRef = useRef(null);
//   const chartRef = useRef(null);

//   useEffect(() => {
//     if (!canvasRef.current) return;
  
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
  
//     const chart = new Chart(ctx, {
//       type: "line",
//       data: {
//         labels: [],
//         datasets: [
//           {
//             label: "Amplitude",
//             data: [],
//             backgroundColor: "rgba(75, 192, 192, 0.2)",
//             borderColor: "rgba(75, 192, 192, 1)",
//             borderWidth: 1,
//           },
//         ],
//       },
//       options: {
//         maintainAspectRatio: false,
//         scales: {
//           x: {
//             type: "linear",
//             beginAtZero: true,
//           },
//           y: {
//             type: "linear",
//             beginAtZero: true,
//           },
//         },
//       },
//     });
  
//     const updateChart = () => {
//       const X = IDFTOfMagnitudes(points)
    
//       chart.data.labels = X.map((_, i) => i);
//       chart.data.datasets[0].data = X;
//       chart.update();
//     };
  
//     updateChart();
  
//     // Return a cleanup function to destroy the chart when the component is unmounted or the points prop changes
//     return () => {
//       chart.destroy();
//     };
//   }, [points]);  


//   return <canvas ref={canvasRef} width={width} height={height}/>;
// };

// export default InverseFourierTransform;
